const PROFILE_REORDER_PATHNAME = "/api/profile/reorder";

export function isProfileReorderAction(formAction: string | undefined) {
	if (!formAction) {
		return false;
	}

	return (
		new URL(formAction, "http://localhost").pathname ===
		PROFILE_REORDER_PATHNAME
	);
}
